import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse<void>>;

const revokeInviteFromGroup = (id: string, inviteUuid: string): ReturnType => {
    return Request.post(`/groups/${id}/invites/${inviteUuid}/revoke`);
};

export default revokeInviteFromGroup;
